import { SortKeyDirectionName, SortKeyName } from "@/stores/ShipmentList/shipmentListSortStore/constants";

export enum RoleName {
    AmaFreight = "ama-freight-access",
    SCS = "scs-access",
    Employee = "employee-access",
    Client = "client-access",
    Admin = "admin-access",
    SuperAdmin = "super-admin-access",
    WebsiteAdmin = "website-admin-access",
    PimcoreAccess = "ama-pimcore-access",
    DeepAccess = "ama-deep-access",
    GrafanaAccessAdmin = "ama-grafana-access-admin",
    GrafanaAccessEditor = "ama-grafana-access-editor",
    GrafanaAccessViewer = "ama-grafana-access-viewer"
}

export enum AppLanguage {
    German = "de",
    English = "en",
}

export enum TimeZones {
    EuropeBerlin = "Europe/Berlin",
    EuropeAthens = "Europe/Athens"
}

export enum DateFormats {
    EuropeanDate = "DD.MM.YYYY",
    EuropeanDateTime = "DD.MM.YYYY, HH:mm"
}

export const DashboardMapping = {
    [RoleName.AmaFreight]: import.meta.env.VITE_GRAFANA_DASHBOARD_UID_AMA,
    [RoleName.SCS]: import.meta.env.VITE_GRAFANA_DASHBOARD_UID_SCS
};

export const DEFAULT_SORTING = [{ key: SortKeyName.SHIPMENT_NUMBER, order: SortKeyDirectionName.Ascending }];
